import { render, staticRenderFns } from "./modalEditarArchivo.vue?vue&type=template&id=5a99db47&scoped=true"
import script from "./modalEditarArchivo.vue?vue&type=script&lang=js"
export * from "./modalEditarArchivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a99db47",
  null
  
)

export default component.exports